import styled from '@emotion/styled';

export const MainBlock = styled.div`
  border: 4px solid color-mix(in srgb, ${({ theme }) => theme.colors.Gray} 10%, transparent);
  border-radius: ${({ theme }) => theme.radii.panel};
  padding: 40px;

  /* Если родитель — flex, предотвращаем вертикальное растягивание */
  align-self: flex-start;

  /* Картинка управляет высотой блока */
  & > img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;
